import type { OrdersDataByStatus } from '@linka/domain/dtos';
import { useSearchFilters } from './use-search-filters';

export const useSystemFilters = () => {
  const { searchParams } = useSearchFilters();

  return {
    page: Number(searchParams.get('page') ?? 1),
    perPage: 10,
    orderBy: searchParams.get('orderBy') as keyof OrdersDataByStatus,
    sortOrder: searchParams.get('sortOrder') as 'asc' | 'desc' | undefined,
  };
};
